import React from 'react'
import {
  Card,
  CardContent,
  Typography,
  Button,
  Alert,
  CircularProgress,
  ButtonGroup,
} from '@mui/material'
import { Login } from '@mui/icons-material'
import {
  useCertificateContext,
  useLoginContext,
  usePinContext,
  useSessionContext,
} from '../../providers'
import { useSnackbar } from 'notistack'

export const LoginSection: React.FC = () => {
  const { selectedCertificate } = useCertificateContext()
  const { pinCode } = usePinContext()
  const { login, loginLoading } = useLoginContext()
  const { fetchSessions } = useSessionContext()
  const { enqueueSnackbar } = useSnackbar()

  const canLogin =
    (selectedCertificate && pinCode && pinCode.trim()) ||
    selectedCertificate?.pinFromClient

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          UYAP Girişi
        </Typography>

        {!selectedCertificate ? (
          <Alert severity="info" sx={{ mb: 2 }}>
            Giriş yapmak için önce bir sertifika seçin.
          </Alert>
        ) : (
          <Button
            color="primary"
            variant="contained"
            fullWidth
            onClick={async () => {
              try {
                await login()

                await fetchSessions()
                enqueueSnackbar(
                  'Giriş işlemi başarılı! Oturumlar alanından oturum seçiniz.',
                  {
                    variant: 'success',
                  },
                )
              } catch (error: any) {
                enqueueSnackbar(error.message, { variant: 'error' })
              }
            }}
            disabled={!canLogin || loginLoading}
            startIcon={<Login />}
          >
            {loginLoading ? <CircularProgress size={24} /> : "UYAP'a Giriş Yap"}
          </Button>
        )}
      </CardContent>
    </Card>
  )
}
